var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-label-container"},[_c('label',{staticClass:"error room-qty-error",attrs:{"id":"order_item_room_quantity-error"}},[_vm._v("\n    "+_vm._s(_vm.$t('roomQtyError'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }